import React from 'react'
import PropTypes from 'prop-types'

const FeaturedProductCard = props => {
  const product = props.product
  let bundleTag

  return (
    <div className='featured-product'>
      <a href={product.url()}>
        <div className='featured-product-bg'>
          <img src={product.bannerPhoto} />
        </div>
        {bundleTag}
        <div className='featured-product-content'>
          <div className='featured-product-details'>
            <div className='featured-product-meta'>
              <div className='featured-prod-label'>Featured</div>
              <div className='product-title'>{product.title}</div>
              <div className='product-coach'>{product.coachLabel()}</div>
            </div>
          </div>
        </div>
      </a>
    </div>
  )
}

FeaturedProductCard.propTypes = {
  product: PropTypes.object
}

export default FeaturedProductCard
